import React from 'react';
import { Check, X } from 'lucide-react';
import { Section } from './Shared';
export const Bitacora = () => {
  const comparison = [{
    situation: 'Querés ir más allá del diagnóstico básico',
    without: 'Te quedás con lo superficial',
    with: 'Usás el péndulo para diagnóstico profundo'
  }, {
    situation: 'Sentís que hay zonas geopáticas en tu casa',
    without: 'No tenés forma de detectarlas',
    with: 'El protocolo de geopatías te guía paso a paso'
  }, {
    situation: 'Querés activar la abundancia en tu hogar',
    without: 'No sabés cómo hacerlo',
    with: 'El Ritual del Oro de 7 días lo activa'
  }, {
    situation: 'Te interesa la geometría sagrada',
    without: 'No sabés cómo aplicarla en casa',
    with: 'Aprendés a usarla para potenciar espacios'
  }, {
    situation: 'Querés un nivel avanzado de protección',
    without: 'Te quedás con lo básico',
    with: 'Técnicas avanzadas de sellado y activación'
  }];
  const checklist = ['Diagnóstico con péndulo paso a paso', 'Protocolo de detección de geopatías', 'Geometría sagrada aplicada al hogar', 'Ritual del Oro de 7 días para abundancia', 'Técnicas avanzadas de sellado energético', 'Activación de rincones de prosperidad', 'Mapa energético avanzado del hogar'];
  return <Section data-id="element-13">
      <div className="text-center mb-12" data-id="element-14">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[23px]" data-id="element-15">
          <span className="mr-3" data-id="element-16">🔮</span> ¿QUÉ AGREGA EL ORÁCULO DEL HOGAR?
        </h2>
      </div>

      {/* Desktop: 3-column grid */}
      <div className="hidden md:block" data-id="element-17">
        <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-18">
          <div className="font-serif font-bold text-lg text-brand-text/90" data-id="element-19">
            Situación
          </div>
          <div className="font-serif font-bold text-lg text-red-500 flex items-center" data-id="element-20">
            <X className="w-5 h-5 mr-2" data-id="element-21" /> Sin Oráculo
          </div>
          <div className="font-serif font-bold text-lg text-brand-gold flex items-center" data-id="element-22">
            <Check className="w-5 h-5 mr-2" data-id="element-23" /> Con Oráculo
          </div>
        </div>
        <div className="space-y-3" data-id="element-24">
          {comparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 glass-panel p-4 rounded-xl items-center" data-id="element-25">
              <div className="text-sm font-medium text-brand-text pr-4" data-id="element-26">
                {row.situation}
              </div>
              <div className="text-sm text-brand-text/80 pr-4" data-id="element-27">
                {row.without}
              </div>
              <div className="text-sm text-brand-gold/90 font-medium bg-brand-gold/10 p-3 rounded-lg border border-brand-gold/20" data-id="element-28">
                {row.with}
              </div>
            </div>)}
        </div>
      </div>

      {/* Mobile: stacked cards */}
      <div className="md:hidden space-y-4" data-id="element-29">
        {comparison.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl space-y-3" data-id="element-30">
            <p className="text-sm font-medium text-brand-text" data-id="element-31">
              {row.situation}
            </p>
            <div className="flex items-start space-x-2" data-id="element-32">
              <X className="w-4 h-4 text-red-500 mt-0.5 shrink-0" data-id="element-33" />
              <span className="text-sm text-brand-text/80" data-id="element-34">{row.without}</span>
            </div>
            <div className="flex items-start space-x-2 bg-brand-gold/10 p-3 rounded-lg border border-brand-gold/20" data-id="element-35">
              <Check className="w-4 h-4 text-brand-gold mt-0.5 shrink-0" data-id="element-36" />
              <span className="text-sm text-brand-gold/90 font-medium" data-id="element-37">
                {row.with}
              </span>
            </div>
          </div>)}
      </div>

      <div className="mt-16 max-w-3xl mx-auto glass-panel p-8 md:p-10 rounded-3xl border-brand-gold/30 relative overflow-hidden" data-id="element-38">
        <div className="absolute top-0 left-0 w-full h-1 gold-gradient-bg" data-id="element-39"></div>
        <h3 className="text-2xl font-serif font-bold mb-8 flex items-center" data-id="element-40">
          <Check className="w-6 h-6 text-brand-gold mr-3" data-id="element-41" /> El Oráculo incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-42">
          {checklist.map((item, i) => <div key={i} className="flex items-start" data-id="element-43">
              <div className="w-1.5 h-1.5 rounded-full bg-brand-gold mt-2 mr-3 shrink-0" data-id="element-44"></div>
              <span className="text-brand-text/90 text-sm leading-relaxed" data-id="element-45">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </Section>;
};